<!-- <ion-header class="custom-ion-header">
  <app-app-header  [title]="pageTitle" [showBackBtn]="showBackBtn"
    [defaultUrl]="defaultUrl"></app-app-header>
</ion-header> -->
<ion-toolbar mode="ios" class="toolbar" [ngStyle]="{'height': headerHeight}">
  <ion-back-button text="" aria-label="dismiss-test"
  role="dismiss-test" 
  Accessibility-ID="dismiss-test" (click)="dismiss()" style="color: white;padding-top:10px"  slot="start" defaultHref="">
  </ion-back-button>
  <ion-title mode="md" class="ion-text-start" style="padding-top:10px;color:white;">
    <ion-text  class="ion-text-start" style="font-weight: bolder;">{{pageTitle}}</ion-text><br>
    <ion-text  class="ion-text-start" style="font-weight: bolder;">{{areaSelected.full_name}} / {{areaSelected.shortDate}}</ion-text>
  </ion-title>
</ion-toolbar>
<ion-content>

  <div  class="card-div">
    <ion-grid class="img-slide">
      <ion-card *ngIf="carouselImages.length>0" class="image-card">
        <swiper-container  [modules]="swiperModules" #swiper class="ion-no-padding slides" paginationType="bullets"
          slidesPerView="1" pager="true">
          <swiper-slide *ngFor="let item of carouselImages">
            <div class="left-arrow" aria-label="left-arrow-test"
            role="left-arrow-test" 
            Accessibility-ID="left-arrow-test" (click)="slidePrev()">
              <ion-icon name="chevron-back-outline"></ion-icon>
            </div>
            <div class="right-arrow" aria-label="right-arrow-test"
            role="right-arrow-test" 
            Accessibility-ID="right-arrow-test" (click)="slideNext()">
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </div>
            <ion-img class="slide-image" [src]="item"></ion-img>
          </swiper-slide>
        </swiper-container>
      </ion-card>
      <ion-card *ngIf="showError" class="empty-image-card">
        <div class="empty-image-content">
          <img class="empty-image" src="assets/area-management/segment_coming_soon.svg" />
          <div>
            <ion-label>We are updating the content.</ion-label>
          </div>
          <div>
            <ion-label>Image will be displayed soon</ion-label>
          </div>
        </div>
      </ion-card>
    </ion-grid>
  </div>
  <div class="main-div">
    <ion-row>
      <ion-col style="display:flex;">
        <div *ngIf="ratingSubmitted=='rating'" class="preferences">
          INDIVIDUAL RATING
         </div>
         <div *ngIf="ratingSubmitted!='rating'" class="preferences">
          OVERALL RATING
         </div>
         <div  style="margin-top: 20px;
         padding-left: 10px;" aria-label="infoPopOver-test"
            role="infoPopOver-test" 
            Accessibility-ID="infoPopOver-test" (click)="infoPopOver($event)">
          <img style="height: 16px;" src="assets/img/profile-page/information.png"/>
         </div>
      </ion-col>
    </ion-row>

    <ion-card style="margin:0px;box-shadow: 0px 0px 6px #00000029;">
      <ion-row style="padding:15px 0px 15px 0px;">
        <ion-col *ngFor="let item of averageRatingDetail;let i=index" class="ion-text-center ion-align-self-center">
          <div>
            <img *ngIf="item.name=='Spillages'" src="assets/img/house-keeping/Spillages_dark.svg"/>
            <img *ngIf="item.name=='Organisations'" src="assets/img/house-keeping/Cleanlines_dark.svg"/>
            <img *ngIf="item.name=='Shines'" src="assets/img/house-keeping/Visual_dark.svg"/>

            <img *ngIf="item.name=='Cleanliness'" src="assets/img/house-keeping/Spillages_dark.svg"/>
            <img *ngIf="item.name=='Availability'" src="assets/img/house-keeping/Cleanlines_dark.svg"/>
            <img *ngIf="item.name=='Comfort'" src="assets/img/house-keeping/Visual_dark.svg"/>
          </div>
          <div style="margin-top:6px;color:#000000DE;font-weight:600;font-size:16px;">
            {{item.name}}
          </div>
          <div *ngIf="loading" style="margin-left:30px;margin-top:6px;">
            <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
          </div>
          <div *ngIf="!loading" [attr.aria-label]="'infoPopOver-test'+i"
          [attr.role]="'infoPopOver-test'+i" 
          [attr.Accessibility-ID]="'infoPopOver-test'+i" style="margin-top:6px;font-size:16px;color:#3CB4AA;font-weight:600;">
            <img style="height:16px;width:16px;" src="assets/img/house-keeping/selected_star.svg"/> {{item.monthRating}}
          </div>
          <div *ngIf="!loading" style="margin-top:6px;">
            <ion-label class="poor" *ngIf="item.monthRating>0 && item.monthRating<=1">
              Poor
            </ion-label>
            <ion-label class="very-poor" *ngIf="item.monthRating>1 && item.monthRating<=2">
              Very Poor
            </ion-label>
            <ion-label class="average" *ngIf="item.monthRating>2 && item.monthRating<=3">
              Average
            </ion-label>
            <ion-label class="good" *ngIf="item.monthRating>3 && item.monthRating<=4">
              Good
            </ion-label>
            <ion-label class="greate" *ngIf="item.monthRating>4 && item.monthRating<=5">
              Greate
            </ion-label>
          </div>
          <div *ngIf="loading" style="margin-left:30px;margin-top:6px;">
            <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
          </div>
        </ion-col>
        <!-- <ion-col class="ion-text-center ion-align-self-center">
          <div>
            <img src="assets/img/house-keeping/Cleanlines_dark.svg"/>
          </div>
          <div style="margin-top:6px;color:#000000DE;font-weight:600;font-size:16px;">
            Cleanlines
          </div>
          <div style="margin-top:6px;font-size:16px;color:#3CB4AA;font-weight:600;">
            <img style="height:16px;width:16px;" src="assets/img/house-keeping/selected_star.svg"/> 4.0
          </div>
          <div style="margin-top:6px;">
            <ion-label style="color:#000000DE;border-radius:4px;background:#E6FCB6;padding:4px;font-size:12px">
            Good
          </ion-label>
          </div>
        </ion-col>
        <ion-col class="ion-text-center ion-align-self-center">
          <div>
            <img src="assets/img/house-keeping/Visual_dark.svg"/>
          </div>
          <div style="margin-top:6px;color:#000000DE;font-weight:600;font-size:16px;">
            Visuals
          </div>
          <div style="margin-top:6px;font-size:16px;color:#3CB4AA;font-weight:600;">
            <img style="height:16px;width:16px;" src="assets/img/house-keeping/selected_star.svg"/> 5.0
          </div>
          <div style="margin-top:6px;">
            <ion-label style="color:#000000DE;border-radius:4px;background:#0091464D;padding:4px;font-size:12px">
            Great
          </ion-label>
          </div>
        </ion-col> -->
      </ion-row>
    </ion-card>

    <ion-row *ngIf="commentList.length>0">
      <ion-col style="display:flex;">
        <div class="preferences">
          COMMENTS
         </div>
      </ion-col>
    </ion-row>
    <ion-grid style="height: 250px;
    overflow: scroll;" *ngIf="commentList.length>0">
      <ion-card style="margin:0px;">
        <div *ngFor="let item of commentList, let i=index">
          <ion-row *ngIf="commentList.length>i+1" style="padding-bottom:4px;color:#000000;font-size:14px;margin:10px 14px 10px 14px;border-bottom:0.1em solid #0073821A;">
            <ion-col size="12">
              <ion-label style="padding-bottom:10px;">
                {{item.name}}
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row  *ngIf="commentList.length==i+1" style="padding-bottom:4px;color:#000000;font-size:14px;margin:10px 14px 10px 14px;">
            <ion-col size="12">
              <ion-label style="padding-bottom:10px;">
                {{item.name}}
              </ion-label>
            </ion-col>
          </ion-row>
        </div>
        
        
      </ion-card>
    </ion-grid>
  </div>
</ion-content>
